import axiosPost from "../axiosPost";

export const SBMDocumentoGet = async (params, credentials) => {
    const { page, pageSize } = params;
    const body = {
        service: "SBMDocumentoGet",
        params,
    };
    const result = await axiosPost(body, credentials);

    if (page !== null && pageSize !== null) {
        return {
            result: result.result,
            total: result.status.id,
            status: result.status,
        };
    }
    return result.result;
};
